export default "__VITE_ASSET__2obspQsw__"